import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Alert, Button } from "react-bootstrap";
import Image from 'react-bootstrap/Image';
import { useNavigate } from 'react-router-dom';
import appVar from '../dataVar/appVar';
import { fetchGetData, fetchPostData } from '../dataVar/apiService';
import logger from '../Utils/logger';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Utils/styles.css';
import { InputText } from "primereact/inputtext";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// Cache-bust de las imágenes de fondo (una vez por carga de página, mismo patrón que Login.js)
const CACHE_BUST = Date.now();

const CambiaPassword_Inic = () => {

    // Estados para los campos
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [password, setPassword] = useState('');
    const [passwordNvo, setPasswordNvo] = useState('');
    const [passwordConf, setPasswordConf] = useState('');
    
    // Estados para visibilidad de contraseñas
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordNvo, setShowPasswordNvo] = useState(false);
    const [showPasswordConf, setShowPasswordConf] = useState(false);
    
    // Estado de carga
    const [cargando, setCargando] = useState(false);
    
    // Estados para errores individuales
    const [passwordError, setPasswordError] = useState("");
    const [passwordNvoError, setPasswordNvoError] = useState("");
    const [passwordConfError, setPasswordConfError] = useState("");
    const [captchaError, setCaptchaRError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [celularError, setCelularError] = useState("");
    
    // Estado para mensaje general
    const [mensaje, setMensaje] = useState({ texto: '', tipo: '' });
    
    // Estado para fortaleza de contraseña
    const [fortaleza, setFortaleza] = useState({
        nivel: 0,
        texto: '',
        color: '',
        mensajes: []
    });

    const navigate = useNavigate();
    
    // Expresión regular corregida - incluye * y escapa correctamente los caracteres especiales
    const passwordRegex = /^(?=.*[a-zñáéíóúü])(?=.*[A-ZÑÁÉÍÓÚÜ])(?=.*\d)(?=.*[$@$!?&+*])[A-Za-zñÑáéíóúüÁÉÍÓÚÜ\d$@$!?&+*]{8,15}$/;
    const emailRegex = /^[a-zA-Z0-9_.+-]{1,64}@[a-zA-Z0-9-]{1,63}\.[a-zA-Z]{2,6}$/;
    const celularRegex = /^3[0-9]{9}$/;

    // Función para evaluar la fortaleza de la contraseña
    const evaluarFortaleza = (password) => {
        let puntos = 0;
        let mensajes = [];

        // Longitud
        if (password.length >= 8) {
            puntos += 1;
            mensajes.push("✓ 8 caracteres o más");
        } else {
            mensajes.push("✗ Mínimo 8 caracteres");
        }

        // Letras minúsculas
        if (/[a-zñáéíóúü]/.test(password)) {
            puntos += 1;
            mensajes.push("✓ Letras minúsculas");
        } else {
            mensajes.push("✗ Incluir letras minúsculas");
        }

        // Letras mayúsculas
        if (/[A-ZÑÁÉÍÓÚÜ]/.test(password)) {
            puntos += 1;
            mensajes.push("✓ Letras mayúsculas");
        } else {
            mensajes.push("✗ Incluir letras mayúsculas");
        }

        // Números
        if (/\d/.test(password)) {
            puntos += 1;
            mensajes.push("✓ Números");
        } else {
            mensajes.push("✗ Incluir números");
        }

        // Caracteres especiales (ahora incluye * y +)
        if (/[$@$!?&+*]/.test(password)) {
            puntos += 1;
            mensajes.push("✓ Caracteres especiales ($@$!?&+*)");
        } else {
            mensajes.push("✗ Incluir caracteres especiales ($@$!?&+*)");
        }

        // Determinar nivel
        let nivel = 0;
        let texto = '';
        let color = '';

        if (password.length === 0) {
            nivel = 0;
            texto = 'Sin contraseña';
            color = '#6c757d';
        } else if (puntos <= 2) {
            nivel = 1;
            texto = 'Débil';
            color = '#dc3545';
        } else if (puntos <= 3) {
            nivel = 2;
            texto = 'Media';
            color = '#ffc107';
        } else if (puntos <= 4) {
            nivel = 3;
            texto = 'Fuerte';
            color = '#28a745';
        } else {
            nivel = 4;
            texto = 'Muy Fuerte';
            color = '#198754';
        }

        return {
            nivel,
            texto,
            color,
            puntos,
            mensajes,
            cumpleRequisitos: puntos >= 4 && password.length >= 8
        };
    };

    // Efecto para evaluar fortaleza cuando cambia la nueva contraseña
    useEffect(() => {
        const resultado = evaluarFortaleza(passwordNvo);
        setFortaleza({
            nivel: resultado.nivel,
            texto: resultado.texto,
            color: resultado.color,
            mensajes: resultado.mensajes,
            cumpleRequisitos: resultado.cumpleRequisitos
        });
    }, [passwordNvo]);

    // Cargar datos del usuario
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                if (!appVar.gCodUsuario) {
                    setMensaje({ 
                        texto: "Usuario no identificado. Redirigiendo al login...", 
                        tipo: "warning" 
                    });
                    setTimeout(() => navigate("/Login"), 2000);
                    return;
                }

                const userArray = await fetchGetData('api/Usuarios/DataUsuario', `${appVar.gCodUsuario}`);
                if (Array.isArray(userArray) && userArray.length > 0) {
                    const xUser = userArray[0];
                    setEmail(xUser.Email || "");
                    setCelular(xUser.Celular || "");
                } else {
                    setMensaje({ 
                        texto: "Usuario no encontrado. Redirigiendo al login...", 
                        tipo: "warning" 
                    });
                    setTimeout(() => navigate("/Login"), 2000);
                }
            } catch (err) {
                logger.error("Error al obtener datos del usuario:", err);
                setMensaje({ 
                    texto: "Error al obtener datos del usuario.", 
                    tipo: "danger" 
                });
            }
        };
        fetchUserData();
    }, [navigate]);

    // Función de validación
    const validarFormulario = () => {
        let hasError = false;

        // Limpiar errores anteriores
        setPasswordError("");
        setPasswordNvoError("");
        setPasswordConfError("");
        setCaptchaRError("");
        setEmailError("");
        setCelularError("");

        // Validar email
        if (!email) {
            setEmailError("Por favor ingrese su email.");
            hasError = true;
        } else if (!emailRegex.test(email)) {
            setEmailError("Email no válido.");
            hasError = true;
        }

        // Validar celular
        if (!celular) {
            setCelularError("Por favor ingrese su celular.");
            hasError = true;
        } else if (!celularRegex.test(celular)) {
            setCelularError("El celular debe empezar por 3 y tener exactamente 10 dígitos.");
            hasError = true;
        }

        // Validar contraseña actual
        if (!password) {
            setPasswordError("Por favor ingrese su contraseña actual.");
            hasError = true;
        } else if (!passwordRegex.test(password)) {
            setPasswordError("Contraseña actual no válida.");
            hasError = true;
        }

        // Validar nueva contraseña
        if (!passwordNvo) {
            setPasswordNvoError("Por favor ingrese la nueva contraseña.");
            hasError = true;
        } else if (!passwordRegex.test(passwordNvo)) {
            setPasswordNvoError("La nueva contraseña no es válida. Entre 8 y 15 caracteres, incluir una letra mayúscula, una minúscula, un número y un carácter especial ($@$!?&+*).");
            hasError = true;
        }

        // Validar confirmación de contraseña
        if (!passwordConf) {
            setPasswordConfError("Por favor confirme la nueva contraseña.");
            hasError = true;
        } else if (passwordNvo !== passwordConf) {
            setPasswordConfError("La nueva contraseña y su confirmación no coinciden.");
            hasError = true;
        }

        // CAPTCHA - CONSERVADO COMO ESTABA
        // if (!captchaVerified) {
        //     setCaptchaRError("Por favor, completa el CAPTCHA.");
        //     hasError = true;
        // }

        return !hasError;
    };

    // Función principal para cambiar contraseña
    const handleCambiarPassword = async (e) => {
        e.preventDefault();

        setMensaje({ texto: '', tipo: '' });

        if (!validarFormulario()) {
            setMensaje({ 
                texto: "Por favor, corrija los errores en el formulario.", 
                tipo: "danger" 
            });
            return;
        }

        if (!appVar.gCodUsuario) {
            setMensaje({ 
                texto: "Error: Usuario no identificado.", 
                tipo: "danger" 
            });
            return;
        }

        setCargando(true);

        try {
            const data = {
                Cod_Usuario: appVar.gCodUsuario || "",
                Password: password || "",
                NuevoPassword: passwordNvo || "",
                Email: email || "",
                Celular: celular || ""
            };

            const cambioArray = await fetchPostData('api/Usuario/CambiarPassword', data);

            if (!cambioArray) {
                setMensaje({ 
                    texto: "No se recibió respuesta del servidor.", 
                    tipo: "danger" 
                });
                setCargando(false);
                return;
            }

            let esExitoso = false;
            let mensajeError = null;

            const respuesta = Array.isArray(cambioArray) ? cambioArray[0] : cambioArray;

            if (respuesta && typeof respuesta === 'object') {
                if (respuesta.Error !== undefined) {
                    if (respuesta.Error === "OK" || respuesta.Error === "0" || respuesta.Error === "") {
                        esExitoso = true;
                    } else {
                        mensajeError = respuesta.Error;
                    }
                } else if (respuesta.Message !== undefined) {
                    if (respuesta.Message === "OK" || respuesta.Message === "0" || respuesta.Message === "") {
                        esExitoso = true;
                    } else {
                        mensajeError = respuesta.Message;
                    }
                } else if (respuesta.mensaje !== undefined) {
                    if (respuesta.mensaje === "OK" || respuesta.mensaje === "0" || respuesta.mensaje === "") {
                        esExitoso = true;
                    } else {
                        mensajeError = respuesta.mensaje;
                    }
                } else if (respuesta.status !== undefined && respuesta.status === "success") {
                    esExitoso = true;
                } else if (respuesta.success !== undefined && respuesta.success === true) {
                    esExitoso = true;
                } else {
                    esExitoso = true;
                }
            } else if (typeof respuesta === 'string') {
                if (respuesta.toLowerCase().includes('exitosamente') || 
                    respuesta.toLowerCase().includes('success') ||
                    respuesta === 'OK' || respuesta === '0' || respuesta === '') {
                    esExitoso = true;
                } else {
                    mensajeError = respuesta;
                }
            } else {
                esExitoso = true;
            }

            if (esExitoso) {
                setMensaje({ 
                    texto: "¡Contraseña cambiada exitosamente! Redirigiendo al login...", 
                    tipo: "success" 
                });
                
                setPassword('');
                setPasswordNvo('');
                setPasswordConf('');
                
                setTimeout(() => {
                    navigate("/Login");
                }, 2000);
            } else {
                setMensaje({ 
                    texto: mensajeError || "Error al cambiar la contraseña. Verifique los datos ingresados.", 
                    tipo: "danger" 
                });
            }

        } catch (error) {
            logger.error("Error completo:", error);
            
            let mensajeError = "Error al procesar la solicitud. Intente nuevamente.";
            
            if (error.message) {
                try {
                    const jsonMatch = error.message.match(/\{.*\}/);
                    if (jsonMatch) {
                        const errorData = JSON.parse(jsonMatch[0]);
                        mensajeError = errorData.Message || errorData.Error || errorData.mensaje || mensajeError;
                    } else {
                        const msgMatch = error.message.match(/Message:\s*([^\n]+)/);
                        if (msgMatch) {
                            mensajeError = msgMatch[1].trim();
                        } else if (error.message.includes('400') || error.message.includes('500')) {
                            mensajeError = "Error del servidor. Verifique los datos ingresados.";
                        } else if (error.message.includes('NetworkError') || error.message.includes('fetch')) {
                            mensajeError = "Error de conexión. Verifique su red.";
                        } else {
                            mensajeError = error.message;
                        }
                    }
                } catch (parseError) {
                    mensajeError = error.message;
                }
            }
            
            setMensaje({ 
                texto: mensajeError, 
                tipo: "danger" 
            });

        } finally {
            setCargando(false);
        }
    };

    const togglePasswordVisibility = (campo) => {
        switch(campo) {
            case 'password':
                setShowPassword(!showPassword);
                break;
            case 'passwordNvo':
                setShowPasswordNvo(!showPasswordNvo);
                break;
            case 'passwordConf':
                setShowPasswordConf(!showPasswordConf);
                break;
            default:
                break;
        }
    };

    const LogoXUECia = '/imagenes/LogoXUECia.png';
    // ?v= por carga de página: el fondo se cambia desde Identidad Corporativa y no debe quedar en caché
    const fondo = `/imagenes/Fondo_RPass.png?v=${CACHE_BUST}`;

    return (
        <Container fluid style={{ height: '100vh' }}>
            <Row style={{ height: '100%' }}>
                <Col sm={6} className='d-none d-sm-block px-0' style={{ height: '100%' }}>
                    <Image
                        src={fondo}
                        alt="Login image"
                        fluid
                        className="w-100"
                        style={{
                            objectFit: 'fill',
                            width: '100%',
                            height: '100%'
                        }}
                    />
                </Col>

                <Col xs={12} sm={6} style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="col-lg-7 p-4" style={{ backgroundColor: 'rgba(255, 255, 255, 0.56)', borderRadius: '20px' }}>

                        <Form onSubmit={handleCambiarPassword}>
                            <Row>
                                <h3>Cambiar Contraseña</h3>
                            </Row>

                            {/* Email */}
                            <div className="p-inputgroup mt-3">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-inbox"></i>
                                </span>
                                <InputText
                                    value={email}
                                    type="email"
                                    placeholder="Email Registrado"
                                    disabled={true}
                                    className={emailError ? 'p-invalid' : ''}
                                />
                            </div>
                            {emailError && <small className="p-error text-danger">{emailError}</small>}

                            {/* Celular */}
                            <div className="p-inputgroup mt-3">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-calculator"></i>
                                </span>
                                <InputText
                                    value={celular}
                                    type="text"
                                    placeholder="Celular Registrado (debe empezar por 3)"
                                    maxLength={10}
                                    disabled={true}
                                    className={celularError ? 'p-invalid' : ''}
                                />
                            </div>
                            {celularError && <small className="p-error text-danger">{celularError}</small>}

                            {/* Contraseña Actual */}
                            <div className="p-inputgroup mt-3">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-key"></i>
                                </span>
                                <InputText
                                    value={password}
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Contraseña actual"
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                        if (passwordError) setPasswordError("");
                                    }}
                                    className={passwordError ? 'p-invalid' : ''}
                                />
                                <span 
                                    className="p-inputgroup-addon" 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => togglePasswordVisibility('password')}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            {passwordError && <small className="p-error text-danger">{passwordError}</small>}

                            {/* Nueva Contraseña */}
                            <div className="p-inputgroup mt-3">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-key"></i>
                                </span>
                                <InputText
                                    value={passwordNvo}
                                    type={showPasswordNvo ? "text" : "password"}
                                    placeholder="Nueva Contraseña"
                                    onChange={(e) => {
                                        setPasswordNvo(e.target.value);
                                        if (passwordNvoError) setPasswordNvoError("");
                                        if (passwordConf && passwordConf !== e.target.value) {
                                            setPasswordConfError("Las contraseñas no coinciden.");
                                        } else if (passwordConf && passwordConf === e.target.value) {
                                            setPasswordConfError("");
                                        }
                                    }}
                                    className={passwordNvoError ? 'p-invalid' : ''}
                                />
                                <span 
                                    className="p-inputgroup-addon" 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => togglePasswordVisibility('passwordNvo')}
                                >
                                    {showPasswordNvo ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            {passwordNvoError && <small className="p-error text-danger">{passwordNvoError}</small>}

                            {/* Indicador de fortaleza */}
                            {passwordNvo && (
                                <div className="mt-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <span>Fortaleza:</span>
                                        <span style={{ color: fortaleza.color, fontWeight: 'bold' }}>
                                            {fortaleza.texto}
                                        </span>
                                    </div>
                                    <div className="progress" style={{ height: '8px', marginTop: '5px' }}>
                                        <div 
                                            className="progress-bar" 
                                            role="progressbar"
                                            style={{ 
                                                width: `${(fortaleza.nivel / 4) * 100}%`,
                                                backgroundColor: fortaleza.color,
                                                transition: 'width 0.3s ease'
                                            }}
                                            aria-valuenow={fortaleza.nivel}
                                            aria-valuemin="0"
                                            aria-valuemax="4"
                                        />
                                    </div>
                                    <small className="text-muted d-block mt-1">
                                        {fortaleza.mensajes && fortaleza.mensajes.map((msg, index) => (
                                            <span key={index} style={{ 
                                                display: 'block',
                                                color: msg.startsWith('✓') ? '#28a745' : '#dc3545',
                                                fontSize: '0.8rem'
                                            }}>
                                                {msg}
                                            </span>
                                        ))}
                                    </small>
                                    <small className="text-muted d-block mt-1">
                                        <span style={{ color: '#6c757d' }}>
                                            Caracteres permitidos: letras (mayúsculas/minúsculas), números y especiales ($@$!?&+*)
                                        </span>
                                    </small>
                                </div>
                            )}

                            {/* Confirmar Nueva Contraseña */}
                            <div className="p-inputgroup mt-3">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-key"></i>
                                </span>
                                <InputText
                                    value={passwordConf}
                                    type={showPasswordConf ? "text" : "password"}
                                    placeholder="Confirme Nueva Contraseña"
                                    onChange={(e) => {
                                        setPasswordConf(e.target.value);
                                        if (passwordConfError) setPasswordConfError("");
                                        if (passwordNvo && passwordNvo !== e.target.value) {
                                            setPasswordConfError("Las contraseñas no coinciden.");
                                        } else if (passwordNvo && passwordNvo === e.target.value) {
                                            setPasswordConfError("");
                                        }
                                    }}
                                    className={passwordConfError ? 'p-invalid' : ''}
                                />
                                <span 
                                    className="p-inputgroup-addon" 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => togglePasswordVisibility('passwordConf')}
                                >
                                    {showPasswordConf ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            {passwordConfError && <small className="p-error text-danger">{passwordConfError}</small>}

                            {/* CAPTCHA - CONSERVADO EXACTAMENTE COMO ESTABA */}
                            {/* <div className="d-flex justify-content-center mt-3">
                                <ReCAPTCHA sitekey={siteKey} onChange={handleCaptcha} />
                            </div>
                            {captchaError && <small className="p-error text-danger">{captchaError}</small>} */}

                            {/* Botón de envío */}
                            <div className="d-flex justify-content-center mt-3">
                                <Button 
                                    variant="primary"
                                    type="submit"
                                    disabled={cargando}
                                    style={{ width: '100%', padding: '10px' }}
                                >
                                    {cargando ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Procesando...
                                        </>
                                    ) : (
                                        <>
                                            <i className="pi pi-sync me-2"></i>
                                            Cambiar Contraseña
                                        </>
                                    )}
                                </Button>
                            </div>

                            <div className="text-center mb-3 mt-2">
                                <Image src={LogoXUECia} width={100} alt="LogoXUECia" />
                            </div>

                            {mensaje.texto && (
                                <div className="mt-3">
                                    <Alert variant={mensaje.tipo === 'success' ? 'success' : 'danger'}>
                                        {mensaje.texto}
                                    </Alert>
                                </div>
                            )}

                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default CambiaPassword_Inic;